<div class="header">
    <h2>{{ 'modules.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="modules-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'modules.error.unavailable' | translate" />
} @else if (module(); as module) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ module.name }}</h1>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'modules.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'modules.form.description' | translate }}</span>
                @if (module.description) {
                    <span class="value pre">{{ module.description }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div>

        <div class="section">
            <h2>{{ 'modules.items.title' | translate }}</h2>
            @if (itemsList().length > 0) {
                <div class="items">
                    @for (item of itemsList(); track item.id; let i = $index) {
                        <a class="item" [routerLink]="item.link" [attr.data-test]="'modules-view-item-' + item.id">
                            <p-badge [value]="'' + (i + 1)" severity="secondary" />
                            <span class="name">{{ item.name }}</span>
                            <p-tag [value]="item.type" [severity]="item.type === 'lesson' ? 'info' : 'warn'" />
                            <i class="pi pi-chevron-right chevron"></i>
                        </a>
                    }
                </div>
            } @else {
                <p class="empty">{{ 'modules.items.empty' | translate }}</p>
            }
        </div>
    </div>

    <div class="footer">
        <app-delete-button [moduleId]="module.id" [saving]="saving()" testId="modules-view-delete" />
        <p-button [label]="'modules.detail.edit' | translate" icon="pi pi-pencil" data-test="modules-view-edit" (onClick)="onEdit()" />
    </div>
}
